var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM7.2666 8.51758L6.04102 7.29297L4.62695 8.70703L6.62695 10.707L7.40039 11.4814L8.10156 10.6406L11.4355 6.64062L9.89844 5.35938L7.2666 8.51758Z",
    fill: "#1AA758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneFillIcon);
export default __webpack_public_path__ + "static/media/done-fill-icon.ffa936aeb294c8c557bcd5ffb42596da.svg";
export { ForwardRef as ReactComponent };